import { render } from "./NotificationBell.vue?vue&type=template&id=5f80e512&scoped=true"
import script from "./NotificationBell.vue?vue&type=script&lang=js"
export * from "./NotificationBell.vue?vue&type=script&lang=js"

import "./NotificationBell.vue?vue&type=style&index=0&id=5f80e512&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f80e512"]])

export default __exports__